import script from "./chatbase.vue?vue&type=script&lang=ts&setup=true"
export * from "./chatbase.vue?vue&type=script&lang=ts&setup=true"

import "./chatbase.vue?vue&type=style&index=0&id=3686dfb6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3686dfb6"]])

export default __exports__